// extracted by mini-css-extract-plugin
module.exports = {"summary":"LeadSummary_summary__2tr4U"};